import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@babackapp/ui/components/select";
import {
  FIELD_DEFINITIONS,
  type FieldDefinition,
  type FieldIdDefinition,
} from "@/lib/override-rules";
import useTranslation from "@babackapp/translations/use-translation";

interface FieldSelectorProps {
  value: FieldIdDefinition;
  onChange: (value: string) => void;
  placeholder?: string;
  disabled?: boolean;
}

export function FieldSelector({
  value,
  onChange,
  placeholder = "Field",
  disabled,
}: FieldSelectorProps) {
  const t = useTranslation();
  return (
    <Select value={value} onValueChange={onChange} disabled={disabled}>
      <SelectTrigger
        className="h-8 min-w-[8rem] max-w-fit"
        title={t(`overrideRules.fields.${value}.description`)}
      >
        <SelectValue placeholder={placeholder} />
      </SelectTrigger>
      <SelectContent className="max-h-48">
        {FIELD_DEFINITIONS.map((field: FieldDefinition) => (
          <SelectItem
            key={field.id}
            value={field.id}
            title={t(`overrideRules.fields.${field.id}.description`)}
          >
            {t(`overrideRules.fields.${field.id}.label`)}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
